import { createNode } from '@glueapp/graph-types';
import { SlackIntegration } from './SlackIntegration';
import { FileDataType } from '@glueapp/graph-types';

export const SlackFileShared = createNode({
    triggerType: 'Integration',
    hideInherentInPort: true,
    id: 'Slack: File Shared',
    name: 'Slack: File Shared',
    description: 'Triggers when a file is shared in the selected channel',
    aiDescription:
        'Trigger node that fires when a file is shared in the selected Slack channel. Requires the Slack integration to be connected. The channel is selected via the slack-channel-selector interface component, which stores the selection in node state. Outputs a "File" (file) port containing the downloaded file data and its type.',
    category: 'Slack',
    color: '#962598',
    triggerEventIdentifier: 'SlackFileShared',
    integration: SlackIntegration,
    inPorts: {
        Channel: { kind: 'string' },
    },
    outPorts: {
        File: FileDataType,
    },
    isAsync: true,
    interfaceComponentId: 'slack-channel-selector',
    execute: async function (input) {
        const fileId = input.payload.fileId;
        if (fileId) {
            try {
                const fileInfoResponse = await input.integration.callIntegration<
                    { ok: true; file: { pretty_type: string; url_private: string } } | { ok: false; error: any }
                >({
                    url: `https://slack.com/api/files.info?file=${fileId}`,
                    method: 'get',
                });

                if (fileInfoResponse.data.ok) {
                    const fileLoadResponse = await input.integration.callIntegration<string>({
                        url: fileInfoResponse.data.file.url_private,
                        method: 'get',
                        responseType: 'blob',
                    });
                    return {
                        output: {
                            File: {
                                fileType: fileInfoResponse.data.file.pretty_type ?? 'unknown file type',
                                data: fileLoadResponse.data,
                            },
                        },
                    };
                }
            } catch (e) {}
        }
        return {
            output: {
                File: null,
            },
        };
    },
});
